import cloneDeep from 'lodash/cloneDeep';

export default {
  INIT_EDITOR(state, {
    contentId, fields, fieldsConfig, fieldsLines = {}, masterChannelValues, finished = false, previewUrl = null,
  }) {
    state.contentId = contentId;
    state.flags = {};
    state.fieldsConfig = fieldsConfig;
    state.fieldsLines = fieldsLines;
    state.masterChannelValues = masterChannelValues;
    state.master = fields;
    state.draft = cloneDeep(fields);
    state.errors = [];
    state.finished = finished;
    state.previewUrl = previewUrl;
  },
  RESET_EDITOR(state) {
    state.contentId = null;
    state.flags = {};
    state.fieldsConfig = [];
    state.fieldsLines = {};
    state.masterChannelValues = { };
    state.master = {};
    state.draft = {};
    state.errors = [];
    state.finished = false;
    state.previewUrl = null;
  },
  UPDATE_DRAFT(state, fields) {
    state.draft = { ...state.draft, ...cloneDeep(fields) };
  },
  SET_FORM_ERRORS(state, errors) {
    state.errors = cloneDeep(errors);
  },
  SET_MASTER(state, master) {
    state.master = master;
    state.draft = cloneDeep(master);
  },
  SET_MASTER_CHANNEL_VALUES(state, masterChannelValues) {
    state.masterChannelValues = masterChannelValues;
  },
  SET_FIELDS_LINES(state, fieldsLines) {
    state.fieldsLines = fieldsLines;
  },
  SET_PREVIEW_URL(state, previewUrl) {
    state.previewUrl = previewUrl;
  },
  SET_FINISHED(state, finished) {
    state.finished = finished;
  },
  SET_FORM_FLAGS(state, flags) {
    state.flags = cloneDeep(flags);
  },
};
